export default interface LivemapDefaultStyle {
  flex: 1;
}
